/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useMemo, useState } from 'react';
import type { U3403InitLU } from './U3403Service';

export interface U3403ContextType {
  initLU: U3403InitLU;
  setInitLU: React.Dispatch<React.SetStateAction<U3403InitLU>>;
}

const U3403Context = createContext<U3403ContextType | undefined>(undefined);

interface U3403ContextProviderProps {
  initLU: U3403InitLU;
  children: React.ReactNode;
}

export const U3403ContextProvider: React.FC<U3403ContextProviderProps> = ({
  initLU,
  children,
}) => {
  const [initLUState, setInitLU] = useState(initLU);

  const value = useMemo(
    () => ({
      initLU: initLUState,
      setInitLU,
    }),
    [initLUState],
  );

  return <U3403Context.Provider value={value}>{children}</U3403Context.Provider>;
};

export function useU3403Context(): U3403ContextType {
  const ctx = useContext(U3403Context);
  if (!ctx) {
    throw new Error('useU3403Context must be used within U3403ContextProvider');
  }
  return ctx;
}
